"use client";
import YouTubeIllustration from "@/common/svgs/youtube-illustration.svg";
import { YouTubeChannelConnectButton } from "@/common/youtube-channel-connect-button";
import Image from "next/image";

function CreateLinkSite() {
    return (
        <>
            <h1 className="mb-4 text-center font-bold text-6xl">Dear Creator</h1>
            <p className="max-w-md text-balance text-center text-muted-foreground">
                Connect your YouTube channel to receive a customized offer.
            </p>
            <div className="my-8">
                <Image src={YouTubeIllustration} alt="asdf" width={300} height={300} />
            </div>
            <YouTubeChannelConnectButton />
        </>
    );
}

export default CreateLinkSite;
